import React from 'react';
import { getStylesByType } from './DataGridColumnBlank.utilities';
export var DataGridColumnBlankBase = function (props) {
    var _a = props.emptyColumnAriaLabel, emptyColumnAriaLabel = _a === void 0 ? 'no value' : _a, dataGridColumnProcessedStyle = props.dataGridColumnProcessedStyle, text = props.text, type = props.type;
    var styling = getStylesByType(type, dataGridColumnProcessedStyle);
    return (React.createElement("div", { "aria-label": emptyColumnAriaLabel, className: String(styling) }, text));
};
//# sourceMappingURL=DataGridColumnBlank.base.js.map